export default {
  props: {
    menuData: {
      type: Object,
      default: null
    },
    checkedId: {
      type: [String, Number],
      default: ''
    },
    isLast: {
      type: Boolean,
      default: false
    },
    defaultShowLimit: {
      //初始展示个数[缺省值]
      type: Number,
      default: 6
    }
  },

  data() {
    return {
      menuList: [],
      expandStatus: 0 //0未展开 1展开

    };
  },

  computed: {
    showExpandBtn: function () {
      return this.menuData.content.length > this.defaultShowLimit;
    }
  },
  methods: {
    checkedChange(e) {
      this.$emit('checkedChange', e);
    },

    expand() {
      if (this.expandStatus === 0) {
        this.expandStatus = 1;
        this.menuList = this.menuData.content;
      } else {
        this.expandStatus = 0;
        this.menuList = this.menuData.content.slice(0, this.defaultShowLimit);
      }
    }

  },

  created() {
    this.menuList = this.menuData.content.slice(0, this.defaultShowLimit);
  }

};